import { Box, Flex, Grid, Heading } from "@sidelinesports/fan-design-system";
import { PowerupFillIcon } from "@sidelinesports/icons";
import type { ApiPick, ApiPlayerDetails } from "../../../../api/index.ts";
import styles from "./PlayerCard.module.css";

export type PlayerCardProps = {
  player: ApiPlayerDetails;
  pick: ApiPick;
  points: number | null;
  index: number;
  onClick?: () => void;
};

export const PlayerCard = ({
  player,
  pick,
  points,
  index,
  ...props
}: PlayerCardProps) => {
  const pointsAsString = points?.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return (
    <div className={styles.card} data-index={index} {...props}>
      <div className={styles["interior-clipping-container"]}>
        <div
          className={styles["image-overlay"]}
          style={{
            backgroundImage: `url(${player.headshot.url})`,
          }}
        />
        <Flex direction="column" justify="between" h="100%" w="100%">
          <Box
            bg="white"
            className={styles["points-container"]}
            p={2}
            pr={4}
            data-surface-color="light"
          >
            <Flex align="center" gap={2}>
              <PowerupFillIcon fontSize={16} />
              <Heading level={6}>{pick.powerupPoints}</Heading>
            </Flex>
          </Box>
          <Grid
            id={`player-${player.id}-name`}
            className={styles["player-name-container"]}
            p={8}
          >
            <Heading as="div" level={1}>
              {pointsAsString ?? "—"}
            </Heading>
            <Heading as="div" level={5}>
              {player.initialAndLastName}
            </Heading>
          </Grid>
        </Flex>
      </div>
    </div>
  );
};
